import React, { useState, useEffect, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import { useDispatch ,useSelector} from "react-redux";
import {addUsers} from "../../store/actions/userAction";

const CustomColorCheckbox = withStyles({
  root: {
    color: "#23AFC4",
    "&$checked": {
      color: "#23AFC4",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
export default function RenderCheckBox(props) {
  const { item } = props;
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const accessUser = useSelector((state) => state.user);

  useEffect(() => {
    const found = accessUser?.data?.find((m) => m.member_id === item.member_id);

    if (found) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [accessUser?.data, item]);

  const handleChange = (e) => {
    setChecked(e.target.checked);

    if (e.target.checked) {
      if(accessUser?.data){
        dispatch(addUsers([...accessUser.data, {...item}]))
      }else{
        dispatch(addUsers([{...item}]))
      }

    } else {
      const newData = accessUser?.data.filter((itm) => itm.member_id !== item.member_id)
      dispatch(addUsers([...newData]))
    }
  };
  return (
    <Fragment>
      {checked && (
        <CustomColorCheckbox
          checked
          style={{
            transform: "scale(0.7)",
          }}
          onChange={handleChange}
        />
      )}

      {!checked && (
        <CustomColorCheckbox
          style={{
            transform: "scale(0.7)",
          }}
          onChange={handleChange}
        />
      )}
    </Fragment>
  );
}
